import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var MatchingSubQuestionReport = /*#__PURE__*/function (_Entity) {
  _inherits(MatchingSubQuestionReport, _Entity);

  var _super = _createSuper(MatchingSubQuestionReport);

  function MatchingSubQuestionReport() {
    _classCallCheck(this, MatchingSubQuestionReport);

    return _super.apply(this, arguments);
  }

  _createClass(MatchingSubQuestionReport, [{
    key: "subQuestionId",
    get: function get() {
      return this.props.subQuestionId;
    }
  }, {
    key: "correctAnswerPercentage",
    get: function get() {
      return this.props.correctAnswerPercentage;
    }
  }, {
    key: "totalCorrectAnswers",
    get: function get() {
      return this.props.totalCorrectAnswers;
    }
  }, {
    key: "wrongAnswerPercentage",
    get: function get() {
      return this.props.wrongAnswerPercentage;
    }
  }, {
    key: "totalWrongAnswers",
    get: function get() {
      return this.props.totalWrongAnswers;
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var guardCollection = [{
        argument: props.subQuestionId,
        argumentName: 'Sub Question Id'
      }, {
        argument: props.correctAnswerPercentage,
        argumentName: 'Correct Answer Percentage'
      }, {
        argument: props.totalCorrectAnswers,
        argumentName: 'Total Correct Answers'
      }, {
        argument: props.wrongAnswerPercentage,
        argumentName: 'Wrong Answer Percentage'
      }, {
        argument: props.totalWrongAnswers,
        argumentName: 'Total Wrong Answers'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new MatchingSubQuestionReport(props, new UniqueEntityID(id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var subQuestionId = data.subQuestionId,
            correctAnswerPercentage = data.correctAnswerPercentage,
            totalCorrectAnswers = data.totalCorrectAnswers,
            wrongAnswerPercentage = data.wrongAnswerPercentage,
            totalWrongAnswers = data.totalWrongAnswers;
        var matchingSubQuestionReportOrError = this.create({
          subQuestionId: subQuestionId,
          totalCorrectAnswers: totalCorrectAnswers,
          correctAnswerPercentage: correctAnswerPercentage,
          wrongAnswerPercentage: wrongAnswerPercentage,
          totalWrongAnswers: totalWrongAnswers
        });

        if (matchingSubQuestionReportOrError.isFailure) {
          return Result.fail(matchingSubQuestionReportOrError.error);
        }

        var matchingSubQuestionReport = matchingSubQuestionReportOrError.getValue();
        return Result.ok(matchingSubQuestionReport);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MatchingSubQuestionReport;
}(Entity);